import {faChevronDown} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, {useState} from 'react';
import Style from 'styles/components/faq.module.scss';
import CommonStyle from 'styles/components/common.module.scss';
import PageNation from 'components/PageNation';
import {Link} from 'gatsby';
import { useLocation } from "@reach/router";

const ITEMS_PER_PAGE = 10;

const Accordion = ({ title, content }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className={classNames(Style.faq__title)} onClick={() => setOpen(!open)}>
        <span className={classNames(Style.faq__title__q)}>Q</span>
        <span>{title}</span>
        <span className={classNames({ [Style.faq__title__icon]: true, [Style.reverse]: open })}>
          <FontAwesomeIcon icon={faChevronDown} />
        </span>
      </div>
      <div className={classNames({ [Style.faq__content]: true, [Style.open]: open })}>
        <span className={classNames(Style.faq__content__a)}>A</span>
        <div className={classNames({ [Style.faq__content__text]: true })}>{content}</div>
      </div>
    </>
  );
}

const TopFAQPresenter = ({ faq }) => {
  return (
    <section className={Style.faq__topFaq}>
      <div className={classNames(Style.faq__catch)}>
        <span>{faq.title}</span>
      </div>
      <div className={classNames(Style.faq__list)}>
        {faq.rows.map(row => (
          <Accordion key={row.title} title={row.title} content={row.content} />
        ))}
      </div>
      <Link className={Style.faq__button} to='/faq'>
        MORE&nbsp;&nbsp;&gt;
      </Link>
    </section>
  );
};

const FAQPresenter = ({ faq }) => {

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = Number(queryParams.get("page"));
  const currentPage = isNaN(page) || page < 1 ? 1 : page;
  
  const totalPages = Math.ceil(faq.rows.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentFaqList = faq.rows.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  return (
    <section className={Style.faq__faqPage}>
      <div className={classNames(Style.faq__catch)}>
        <span>{faq.title}</span>
      </div>
      <div className={classNames(Style.faq__list)}>
        {currentFaqList.map(row => (
          <Accordion key={row.title} title={row.title} content={row.content} />
        ))}
      </div>
      <div className={Style.pagenation}>
        <PageNation
          page="/faq"
          currentPage={currentPage}
          totalPages={totalPages}
          />
      </div>
    </section>
  );
};

const topFAQ = {
  title: 'よくある質問',
  rows: [
    {
      title: '初めてで知識が無いのですが、問題なくショップ開設・運営は行えますか？',
      content: (
        <>
          はい、comachicartはプログラミングなどの専門的な知識を必要とせず、直観的に操作が行えるサービスとなっています。また、
          <a href='https://manual.comachicart.com/'>オンラインマニュアル</a>
          のご用意もありますし、適宜専任の担当者がサポートさせていただきますので、ご安心ください。
        </>
      ),
    },
    {
      title: '料金プランに記載の手数料以外でかかる費用はありますか？',
      content: (
        <>
          導入される決済手段（PayPayなど）によって決済手数料が発生いたします。有料アプリを利用の場合は、各アプリで定められた料金が発生いたします。<br />
          詳細につきましてはお問い合わせいただくか、お打ち合わせ時に営業担当よりご説明させていただきます。
        </>
      ),
    },
    {
      title: "カートシステム利用料金はどのように支払いますか？",
      content: <>「銀行振込」または「クレジットカード決済」からお支払い方法をご選択いただけます。</>,
    },
  ],
};

const priceFAQ = {
  title: 'よくある質問',
  rows: [
    {
      title: "カートシステム利用料金はどのように支払いますか？",
      content: <>「銀行振込」または「クレジットカード決済」からお支払い方法をご選択いただけます。</>,
    },
    {
      title: '各決済サービスの利用料はどのように支払いますか？',
      content: (
        <>
          各決済サービス提供会社様とのご契約内容に応じてお支払いください。<br />
          ※当社に対するお支払いではございませんのでご注意ください。
        </>
      ),
    },
    {
      title: "売上金はどのように入金されますか？",
      content: 
        <>
          comachicartで販売した商品の売上金は、当社からの入金ではなく購入者様あるいは各決済サービス提供会社様からのご入金となります。<br />
          （例1）銀行振込の場合<br />
            　comachicart上で振込先口座を設定することができます。<br />
            　ご注文完了後、購入者様が設定済みの振込先口座へ直接入金いただくことになります。<br />
          （例2）クレジットカード決済の場合<br />
            　株式会社ゼウス様とのご契約内容に応じて入金されます。<br />
            　入金サイクルなど、ご契約内容の詳細は株式会社ゼウス様にご確認をお願い致します。<br />
        </>,
    },
  ],
};

const FAQList = {
  title: 'よくある質問',
  rows: [
    {
      title: '初めてで知識が無いのですが、問題なくショップ開設・運営は行えますか？',
      content: (
        <>
          はい、comachicartはプログラミングなどの専門的な知識を必要とせず、直観的に操作が行えるサービスとなっています。また、
          <a href='https://manual.comachicart.com/'>オンラインマニュアル</a>
          のご用意もありますし、適宜専任の担当者がサポートさせていただきますので、ご安心ください。
        </>
      ),
    },
    {
      title: 'どこからサービスの申込ができますか？',
      content:
        <>
          当ページの右上にある「申し込む」のボタンよりお申込みいただけます。<br />
          comachicartサービス利用規約にご同意の上、ボタンをクリックした後に表示される画面の案内に従って必要事項をご入力ください。
        </>
    },
    {
      title: "料金プランに記載の手数料以外でかかる費用はありますか？",
      content: (
        <>
          導入される決済手段（PayPayなど）によって決済手数料が発生いたします。有料アプリを利用の場合は、各アプリで定められた料金が発生いたします。<br />
          詳細につきましてはお問い合わせいただくか、お打ち合わせ時に営業担当よりご説明させていただきます。
        </>
      ),
    },
    {
      title: "カートシステム利用料金はどのように支払いますか？",
      content: <>「銀行振込」または「クレジットカード決済」からお支払い方法をご選択いただけます。</>,
    },
    {
      title: "売上金はどのように入金されますか？",
      content: 
        <>
          comachicartで販売した商品の売上金は、当社からの入金ではなく購入者様あるいは各決済サービス提供会社様からのご入金となります。<br />
          （例1）銀行振込の場合<br />
            　comachicart上で振込先口座を設定することができます。<br />
            　ご注文完了後、購入者様が設定済みの振込先口座へ直接入金いただくことになります。<br />
          （例2）クレジットカード決済の場合<br />
            　株式会社ゼウス様とのご契約内容に応じて入金されます。<br />
            　入金サイクルなど、ご契約内容の詳細は株式会社ゼウス様にご確認をお願い致します。<br />
        </>,
    },
    {
      title: "導入できる決済手段は何がありますか？",
      content: 
        <>
          銀行振込、代金引換、クレジットカード決済、ID決済（PayPayなど）をご導入いただけます。<br />
          ご導入するために別途各決済サービス提供会社様へお申込みしていただく必要がございます。<br />
          詳しくは<a href='/func/'>機能ページ</a>をご覧ください。
        </>,
    },
    {
      title: "ネットショップのデザインは簡単に作れますか？",
      content: 
        <>
          専門的な知識がなくてもデザインテンプレートやパーツを組み合わせるだけで、簡単にデザインができあがります。<br />
          詳しくは<a href='/design/'>デザインページ</a>をご覧ください。
        </>,
    },
  ],
};

export const TopFAQ = () => {
  return <TopFAQPresenter faq={topFAQ} />;
};

export const PriceFAQ = () => {
  return <TopFAQPresenter faq={priceFAQ} />;
};


export const FAQ = () => {
return < FAQPresenter faq = {FAQList} />;
};
